import React from 'react'
import FiltersIconSVG from "../../../assets/icons/filters-icon.svg"
export const FiltersIcon: React.FC = () => {
  return (
    <img src={FiltersIconSVG} alt="" className="w-[50px] h-[50px] cursor-pointer"/>
  )
}
